import script from "./AppNotificationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotificationItem.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotificationItem.vue?vue&type=style&index=0&id=eeb50f34&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeb50f34"]])

export default __exports__